import React, { Component } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import axios from 'axios';
import Loader from "../../../components/Loader";
import InspectedSchools from "../Charts/SystemAdmin/InspectedSchools";
import ProgressGraph from "../Charts/SystemAdmin/ProgressGraph";
import moment from "moment";
import { School, Apartment } from '@material-ui/icons';
import { Button, Form, FormGroup, Input } from 'reactstrap';
import backend_url from "../../../routes/API_URL";
import swal from 'sweetalert';

const API_URL = backend_url['api_url'];

class SystemAdminDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dashboardData: null,
            loading: true,
            hasError: false,
            bearer_auth: window.sessionStorage.getItem('token'),
            startDate: moment().startOf('year').format('YYYY-MM-DD'),
            endDate: moment().endOf('year').format('YYYY-MM-DD'),
            errorMessage: ''
        };

        this.abortController = new AbortController();
        this.sendNESNotifications = this.sendNESNotifications.bind(this);
        this.loadDashboardData = this.loadDashboardData.bind(this);
    }

    loadDashboardData() {
        this.setState({ loading: true, hasError: false });
        
        axios.get(`${API_URL}/dashboard/stats`, { 
            headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }, 
            signal: this.abortController.signal 
        })
        .then(response => {
            if (response.data.success) {
                this.setState({
                    dashboardData: response.data.data,
                    loading: false
                });
            } else {
                throw new Error(response.data.message || 'Failed to load dashboard data');
            }
        })
        .catch(error => {
            if (error.name === 'AbortError') {
                return; // Request was cancelled
            }
            
            let errorMessage = "Failed to load the dashboard data. ";
            
            if (error.response?.status === 401) {
                errorMessage = "Your session has expired. You'll automatically be logged out within seconds.";
                
                swal({
                    title: "",
                    text: errorMessage,
                    icon: "error",
                    timer: 2000
                }).then(() => {
                    window.sessionStorage.clear();
                    window.location.reload();
                });
            } else {
                swal({
                    title: "",
                    text: errorMessage + "We will refresh the page in seconds..",
                    icon: "error",
                    timer: 5000
                }).then(() => {
                    window.location.reload();
                });
            }
            
            this.setState({ 
                hasError: true, 
                loading: false,
                errorMessage: errorMessage
            });
        });
    }

    componentDidMount() {
        this.loadDashboardData();
    }

    componentWillUnmount() {
        this.abortController.abort();
    }

    sendNESNotifications() {
        this.setState({ loading: true });
        
        axios.post(`${API_URL}/nes_requirements/send_notifications?start_date=${this.state.startDate}&end_date=${this.state.endDate}`, {}, {
            headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
        })
        .then(resp => {
            this.setState({ loading: false });
            
            if (resp.status < 300) {
                swal({
                    title: 'Success',
                    text: 'Successfully sent emails for specified visits',
                    icon: 'success'
                });
            } else {
                swal({
                    title: 'Error',
                    text: 'Something went wrong',
                    icon: 'error'
                });
            }
        })
        .catch(error => {
            this.setState({ loading: false });
            swal({
                title: 'Error',
                text: 'Failed to send notifications',
                icon: 'error'
            });
        });
    }

    render() {
        const { dashboardData, loading, hasError } = this.state;

        // Extract data from dashboardData with fallbacks
        const primData = dashboardData ? { COUNT: dashboardData.primary_schools || 0 } : { COUNT: 0 };
        const secData = dashboardData ? { COUNT: dashboardData.secondary_schools || 0 } : { COUNT: 0 };
        const zonesData = dashboardData ? { COUNT: dashboardData.zones || 0 } : { COUNT: 0 };
        const clustersData = dashboardData ? { COUNT: dashboardData.clusters || 0 } : { COUNT: 0 };
        const constituenciesData = dashboardData ? { COUNT: dashboardData.constituencies || 0 } : { COUNT: 0 };
        const districtsData = dashboardData ? { COUNT: dashboardData.districts || 0 } : { COUNT: 0 };
        const divisionsData = dashboardData ? { COUNT: dashboardData.divisions || 0 } : { COUNT: 0 };
        const standardsData = dashboardData ? { COUNT: dashboardData.nes_standards || 0 } : { COUNT: 0 };
        const requirementsData = dashboardData ? { COUNT: dashboardData.nes_requirements || 0 } : { COUNT: 0 };
        const levelsData = dashboardData ? { COUNT: dashboardData.nes_levels || 0 } : { COUNT: 0 };
        const nesCategoriesData = dashboardData ? { COUNT: dashboardData.nes_categories || 0 } : { COUNT: 0 };

        return (
            <React.Fragment>
                <div className="container-fluid">
                    <Row className="position-center">
                        {(loading === true) ? <Loader /> : null}
                    </Row>
                    
                    <Row className="align-items-center">
                        <Col sm={6}>
                            <div className="page-title-box">
                                <h4 className="font-size-18">SYSTEM ADMINISTRATION LEVEL</h4>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/#">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Visualization</li>
                                </ol>
                            </div>
                        </Col>

                        <Col sm="6">
                            <div className="float-right d-none d-md-block">
                                {/* Optional: Add refresh button */}
                                {/* <Button color="primary" onClick={this.loadDashboardData} disabled={loading}>
                                    Refresh Data
                                </Button> */}
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Card style={{ padding: '1em' }}>
                                <hr />
                                <h6>Trigger Notifications for Recommendations to Directorates</h6>
                                <hr />
                                <Form>
                                    <FormGroup>
                                        <Row>
                                            <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                                                Start Date
                                            </Col>
                                            <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                                                End Date
                                            </Col>
                                            <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                                                {/* Empty column for alignment */}
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                                                <Input 
                                                    type="date" 
                                                    onChange={(e) => {
                                                        const { value } = e.target;
                                                        this.setState({ startDate: moment(value).format("YYYY-MM-DD") });
                                                    }} 
                                                    defaultValue={this.state.startDate} 
                                                    name="activity_start_date" 
                                                    id="activity_start_date" 
                                                    required={true} 
                                                />
                                            </Col>
                                            <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                                                <Input 
                                                    type="date" 
                                                    defaultValue={this.state.endDate} 
                                                    onChange={(e) => {
                                                        const { value } = e.target;
                                                        this.setState({ endDate: moment(value).format("YYYY-MM-DD") });
                                                    }} 
                                                    name="activity_finish_date" 
                                                    id="activity_finish_date" 
                                                    required={true} 
                                                />
                                            </Col>
                                            <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                                                <Button 
                                                    onClick={this.sendNESNotifications} 
                                                    color="success"
                                                    disabled={loading}
                                                >
                                                    {loading ? 'Processing...' : 'Trigger'}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Form>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Card>
                                <CardBody>
                                    <h6 className="card-title mb-4">QUICK STATISTICS</h6>
                                    <hr className="bg-success" />
                                    
                                    {hasError ? (
                                        <div className="text-center py-4">
                                            <p className="text-danger">Failed to load dashboard data</p>
                                            <Button color="primary" onClick={this.loadDashboardData}>
                                                Retry
                                            </Button>
                                        </div>
                                    ) : (
                                        <>
                                            <Row className="text-white">
                                                <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                                    <Link className="text-success" to="#">
                                                        <Card className="border border-success">
                                                            <CardBody>
                                                                <span className="float-left">Primary Schools</span>
                                                                <span className="float-right"><School fontSize="large" /></span>
                                                                <br />
                                                                <hr />
                                                                <center>
                                                                    <span fontSize="large">
                                                                        <strong>
                                                                            <h2>
                                                                                {loading ? (
                                                                                    <div className="spinner-border spinner-border-sm text-success" role="status">
                                                                                        <span className="sr-only">Loading...</span>
                                                                                    </div>
                                                                                ) : primData['COUNT']}
                                                                            </h2>
                                                                        </strong>
                                                                    </span>
                                                                </center>
                                                            </CardBody>
                                                        </Card>
                                                    </Link>
                                                </Col>

                                                <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                                    <Link className="text-success" to="#">
                                                        <Card className="border border-success">
                                                            <CardBody>
                                                                <span className="float-left">Secondary Schools</span>
                                                                <span className="float-right"><School fontSize="large" /></span>
                                                                <br />
                                                                <hr />
                                                                <center>
                                                                    <span fontSize="large">
                                                                        <strong>
                                                                            <h2>
                                                                                {loading ? (
                                                                                    <div className="spinner-border spinner-border-sm text-success" role="status">
                                                                                        <span className="sr-only">Loading...</span>
                                                                                    </div>
                                                                                ) : secData['COUNT']}
                                                                            </h2>
                                                                        </strong>
                                                                    </span>
                                                                </center>
                                                            </CardBody>
                                                        </Card>
                                                    </Link>
                                                </Col>

                                                <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                                    <Link className="text-success" to="#">
                                                        <Card className="border border-success">
                                                            <CardBody>
                                                                <span className="float-left">Zones</span>
                                                                <span className="float-right"><Apartment fontSize="large" /></span>
                                                                <br />
                                                                <hr />
                                                                <center>
                                                                    <span fontSize="large">
                                                                        <strong>
                                                                            <h2>
                                                                                {loading ? (
                                                                                    <div className="spinner-border spinner-border-sm text-success" role="status">
                                                                                        <span className="sr-only">Loading...</span>
                                                                                    </div>
                                                                                ) : zonesData['COUNT']}
                                                                            </h2>
                                                                        </strong>
                                                                    </span>
                                                                </center>
                                                            </CardBody>
                                                        </Card>
                                                    </Link>
                                                </Col>
                                                
                                                <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                                    <Link className="text-success" to="#">
                                                        <Card className="border border-success">
                                                            <CardBody>
                                                                <span className="float-left">Clusters</span>
                                                                <span className="float-right"><Apartment fontSize="large" /></span>
                                                                <br />
                                                                <hr />
                                                                <center>
                                                                    <span fontSize="large">
                                                                        <strong>
                                                                            <h2>
                                                                                {loading ? (
                                                                                    <div className="spinner-border spinner-border-sm text-success" role="status">
                                                                                        <span className="sr-only">Loading...</span>
                                                                                    </div>
                                                                                ) : clustersData['COUNT']}
                                                                            </h2>
                                                                        </strong>
                                                                    </span>
                                                                </center>
                                                            </CardBody>
                                                        </Card>
                                                    </Link>
                                                </Col>
                                            </Row>
                                            
                                            <hr className="bg-success" />
                                            
                                            {/* Hidden additional stats section - kept for future use */}
                                            <Row hidden className="text-white">
                                                <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                                    <Link className="text-success" to="/constituencies">
                                                        <Card className="border border-success">
                                                            <CardBody>
                                                                <span className="float-left"> Constituencies</span>
                                                                <span className="float-right"><Apartment fontSize="large" /></span>
                                                                <br />
                                                                <hr />
                                                                <center>
                                                                    <span fontSize="large">
                                                                        <strong>
                                                                            <h2>{constituenciesData['COUNT']}</h2>
                                                                        </strong>
                                                                    </span>
                                                                </center>
                                                            </CardBody>
                                                        </Card>
                                                    </Link>
                                                </Col>

                                                <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                                    <Link className="text-success" to="/districts">
                                                        <Card className="border border-success">
                                                            <CardBody>
                                                                <span className="float-left">Districts</span>
                                                                <span className="float-right"><Apartment fontSize="large" /></span>
                                                                <br />
                                                                <hr />
                                                                <center>
                                                                    <span fontSize="large">
                                                                        <strong>
                                                                            <h2>{districtsData['COUNT']}</h2>
                                                                        </strong>
                                                                    </span>
                                                                </center>
                                                            </CardBody>
                                                        </Card>
                                                    </Link>
                                                </Col>

                                                <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                                    <Link className="text-success" to="/divisions">
                                                        <Card className="border border-success">
                                                            <CardBody>
                                                                <span className="float-left">Divisions</span>
                                                                <span className="float-right"><Apartment fontSize="large" /></span>
                                                                <br />
                                                                <hr />
                                                                <center>
                                                                    <span fontSize="large">
                                                                        <strong>
                                                                            <h2>{divisionsData['COUNT']}</h2>
                                                                        </strong>
                                                                    </span>
                                                                </center>
                                                            </CardBody>
                                                        </Card>
                                                    </Link>
                                                </Col>
                                            </Row>
                                            
                                            {/* Debug info (can be removed in production) */}
                                            {dashboardData && dashboardData.timestamp && (
                                                <div className="text-right mt-2">
                                                    <small className="text-muted">
                                                        Updated: {moment(dashboardData.timestamp).fromNow()}
                                                        {dashboardData.cached && ' (cached)'}
                                                    </small>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {/* Charts Sections - Keep existing */}
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Card>
                                <CardBody>
                                    <InspectedSchools />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Card>
                                <CardBody>
                                    <ProgressGraph />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        );
    }
}

export default SystemAdminDashboard;